var footerWidget;

(function() {
    'use strict';
    if (!document.querySelector('#vue-footer')) {
        return;
    }

    footerWidget = new Vue({
        el: '#vue-footer',
        data: function() {
            return {
                isMapShown: false,
                initialized: false,
            };
        },
        computed: {

        },
        methods: {
            showMapModal: function(ev) {
                noScroll.on();
                this.isMapShown = true;
            },

            closeMapModal: function() {
                noScroll.off();
                this.isMapShown = false;
            },

            showCookiesConsent: function() {
                MpEventBus.$emit(EVENT_COOKIE_CONSENT_SHOW);
            },

            init: function() {
                if (this.initialized) {
                    return;
                }

                this.initialized = true;
            },
        },
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();
